// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".customArrowHeight[data-v-7e4b6d52] {\n  height: 38px;\n}\n.customWidthPage[data-v-7e4b6d52] {\n  width: 120px;\n}\n", ""]);
// Exports
module.exports = exports;
